export default "__VITE_ASSET__DV581kQB__"